import React, { useState } from "react";

import { getImgUrl } from "../../../../utills";
import HelpWidgetsModal from "../HelpWidgetsModal";
import ImageRenderr from "../../../ImageRenderr/Index";
import RenderIfAvailable from "../../../RenderIfAvailable";
import { HELP_WIDGETS_ICN, WHATSAPP_GREEN_ICN } from "../../../../GlobalConstant/image";

import styles from "../../HelpFloatWidget.module.scss";

const HelpWidgetsIcn = ({ configData = {} }) => {
  const [helpWidgetsModalFlag, setHelpWidgetsModalFlag] = useState(false);

  const { isWhatsAppEnable = false, isCallBackEnable = false } = configData;

  const handleToggleWidgetsModal = () => {
    setHelpWidgetsModalFlag(prv => !prv)
  }

  return <>
    <div className={styles["help-widget-icn"]} onClick={handleToggleWidgetsModal}>
      <ImageRenderr src={getImgUrl(isWhatsAppEnable && isCallBackEnable ? HELP_WIDGETS_ICN : WHATSAPP_GREEN_ICN)} height="48px" width="48px" />
    </div>
    <RenderIfAvailable value={helpWidgetsModalFlag}>
      <HelpWidgetsModal handleClose={handleToggleWidgetsModal} configData={configData} />
    </RenderIfAvailable>
  </>
}

export default React.memo(HelpWidgetsIcn);
